export const transformDynamicAttributeOptions = dynamicAttributeOptions => {
  if (!(dynamicAttributeOptions !== null && dynamicAttributeOptions !== void 0 && dynamicAttributeOptions.length)) return [];
  return dynamicAttributeOptions.map(_ref => {
    let {
      id,
      title,
      type,
      options
    } = _ref;
    return {
      id,
      title,
      type,
      options: transformDynamicAttributeOptions(options)
    };
  });
};
export const transformDynamicAttribute = _ref2 => {
  let {
    id,
    title,
    code,
    description,
    placeholder,
    display_type,
    selection_type,
    required,
    selection_limit,
    options
  } = _ref2;
  return {
    id,
    title,
    code,
    description,
    placeholder,
    displayType: display_type,
    selectionType: selection_type,
    required,
    selectionLimit: selection_limit,
    options: transformDynamicAttributeOptions(options)
  };
};
export const transformDynamicAttributes = dynamicAttributes => dynamicAttributes.map(transformDynamicAttribute);
export const transformSupportedAttributesToSelectedValues = supportedAttributes => supportedAttributes.map(attr => ({
  field: attr,
  value: []
}));